import type { AskHistoryTurn } from '../types/api'
import type { ChatMessage } from './chat-history'

/** 設計: docs/maruya/maruya-chat-ux-cx6-multiturn-design.md §4 */
export const ASK_HISTORY_DEFAULT_TURNS = 3
export const ASK_HISTORY_QUESTION_MAX_LENGTH = 200
export const ASK_HISTORY_ANSWER_MAX_LENGTH = 300

export function truncateAskText(s: string, maxLen: number): string {
  const trimmed = s.trim()
  const chars = [...trimmed]
  if (chars.length <= maxLen) {
    return trimmed
  }
  return `${chars.slice(0, maxLen).join('')}…`
}

/**
 * 完了済みの user→assistant ペアから直近 N 往復を抽出する。
 * 末尾の未回答 user（送信直前の質問）は含めない。
 */
export function buildAskHistory(
  messages: ChatMessage[],
  maxTurns = ASK_HISTORY_DEFAULT_TURNS,
): AskHistoryTurn[] {
  const pairs: AskHistoryTurn[] = []
  for (let i = 0; i < messages.length; i++) {
    const cur = messages[i]
    const next = messages[i + 1]
    if (cur?.role === 'user' && next?.role === 'assistant') {
      pairs.push({
        question: truncateAskText(cur.content, ASK_HISTORY_QUESTION_MAX_LENGTH),
        answer: truncateAskText(next.content, ASK_HISTORY_ANSWER_MAX_LENGTH),
      })
      i++
    }
  }
  if (maxTurns <= 0) {
    return []
  }
  return pairs.slice(-maxTurns)
}
